import React from "react";
import CheckBoxIcon from "./Icons/CheckBox";
import CheckBoxOutline from "./Icons/CheckBoxOutline";

const CheckBox = ({ isSelected, conditionalDisabledClass = "", onClick }) => {
  const [icon, conditionalColorClass] = isSelected ? [<CheckBoxIcon />, "color--blue"] : [<CheckBoxOutline />, ""];

  const className = `${conditionalColorClass} ${conditionalDisabledClass}`.trim();
  return (
    <div className={className} onClick={onClick}>
      {icon}
    </div>
  );
};

export default CheckBox;
